import * as React from 'react';

export default function ConfirmCircleFilled({
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 25 24"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#232D34"
          d="M12.104 2.25a9.75 9.75 0 1 0 9.75 9.75 9.76 9.76 0 0 0-9.75-9.75Zm4.281 8.03-5.25 5.25a.748.748 0 0 1-1.061 0l-2.25-2.25a.75.75 0 1 1 1.061-1.06l1.72 1.72 4.719-4.72a.751.751 0 0 1 1.061 1.06Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.104 0h24v24h-24z" />
        </clipPath>
      </defs>
    </svg>
  );
}
